import React from "react";
import { Typewriter } from "react-simple-typewriter";
import "./Home.css";
import consultoriaIcon from "../../assets/images/consultoria_icone.png";
import suporteIcon from "../../assets/images/suporte_icone.png";
import infraestruturaIcon from "../../assets/images/infraestrutura-TI.png";

const highlights = [
  {
    icon: consultoriaIcon,
    alt: "Ícone consultoria em TI",
    title: "Consultoria estratégica",
    description: "Desenhamos rotas tecnológicas personalizadas para acelerar seus resultados.",
  },
  {
    icon: suporteIcon,
    alt: "Ícone suporte técnico",
    title: "Suporte contínuo",
    description: "Monitoramento e atendimento 24/7 para manter sua operação sempre disponível.",
  },
];

function Home() {
  return (
    <main className="hero" id="home">
      <div className="hero__grid">
        <div className="hero__content">
          <span className="hero__badge chip">Soluções completas em tecnologia</span>
          <h1>
            Transformamos visões em <span>soluções tecnológicas</span> inovadoras
          </h1>
          <p>
            Integramos estratégia, infraestrutura e suporte especializado para impulsionar empresas que
            precisam de tecnologia confiável, segura e preparada para o futuro.
          </p>

          <div className="hero__typewriter">
            <span className="hero__typewriter-label">Especialistas em</span>
            <span className="hero__typewriter-text">
              <Typewriter
                words={[
                  "Infraestrutura CFTV",
                  "Redes corporativas",
                  "Consultoria em TI",
                  "Administração de Servidores",
                ]}
                loop={Infinity}
                cursor
                cursorStyle="_"
                typeSpeed={50}
                deleteSpeed={50}
                delaySpeed={1200}
              />
            </span>
          </div>

          <div className="hero__actions">
            <a className="primary-button" href="#contact">
              Fale com um especialista
            </a>
            <a className="hero__ghost" href="#services">
              Conheça nossos serviços
            </a>
          </div>

        </div>

        <div className="hero__showcase">
          <div className="hero__floating">
            <h3>Arquitetura, segurança e performance no mesmo ecossistema</h3>
            <p>
              Combinamos planejamento e execução para entregar ambientes altamente disponíveis, com
              governança, observabilidade e resposta rápida a incidentes.
            </p>
            <ul>
              <li>Roadmap tecnológico alinhado ao negócio</li>
              <li>Observabilidade e respostas proativas</li>
              <li>Gestão de riscos e continuidade operacional</li>
            </ul>
          </div>

          <div className="hero__highlight-grid">
            {highlights.map(({ icon, alt, title, description }) => (
              <div className="hero__highlight-card" key={title}>
                <img src={icon} alt={alt} />
                <div>
                  <h4>{title}</h4>
                  <p>{description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <span className="hero__blur hero__blur--one" aria-hidden="true" />
      <span className="hero__blur hero__blur--two" aria-hidden="true" />
    </main>
  );
}

export default Home;
